export default {
  totalCount: 0,
  currentPageFacilities: [],
  selectedFacilities: [],
  initiallySelectedFacilities: [], // for adding to group dialog purposes
  allFacilitiesIds: [],
  cities: []
};
